import React from 'react'
import Top_heading from './component/Top_heading'
import Component_Heading from './component/Component_Heading'
import "./services-component/css/services.css"


export default function PrivacyPolicy() {

  const policySections = [
    {
      id: 1,
      title: 'Confidentiality',
      body: 'Details you submit through our contact form, your name, email, phone number, and website URL are held in confidence. We do not disclose them to any outside party without your consent, except where required by law. Internally, access is limited to Raj Digital Marketing Pvt. Ltd. staff who need it to respond to your enquiry or deliver your project.'
    },
    {
      id: 2,
      title: 'Security measures',
      body: 'We apply reasonable technical and organisational controls, including SSL/TLS encryption on our Site and role-based access restrictions, to guard against loss, misuse, or unauthorised alteration of your information. That said, no transmission over the internet is completely secure, and we cannot guarantee absolute security for data sent to us online.'
    },
    {
      id: 3,
      title: 'Changes to this Policy',
      body: 'We may update this policy from time to time. The revised version takes effect when posted.'
    }
  ]

  return (
    <>
      <Top_heading Heading="PRIVACY POLICY" />

      <div className="additional-div">

      </div>

      <Component_Heading
        heading="CONFIDENTIALITY AND DATA PROTECTION"
        para="Your privacy matters to us. This page explains how Raj Digital Marketing Pvt. Ltd. handles the information you share with us, the safeguards we keep in place to protect it, and how we let you know when this policy changes."
      />

      <div className="privacy-section">
        <div className="privacy-container">

          {policySections.map((section) => (
            <div className="privacy-card" key={section.id}>
              <span className="privacy-card-index">
                {String(section.id).padStart(2, '0')}
              </span>
              <div className="privacy-card-body">
                <h3 className="privacy-card-title">{section.title}</h3>
                <p className="privacy-card-text">{section.body}</p>
              </div>
            </div>
          ))}

          {/* <div className="privacy-note">
            <p>
              Have a question about your data or want it removed from our records? Write to us at{' '}
              <a href="mailto:zoher@rajdigi.com">zoher@rajdigi.com</a> and we will get back to you.
            </p>
          </div> */}

        </div>
      </div>

      <div className="blueStrip">
      </div>
    </>
  )
}
